// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import ProductFeaturesCreatePage from './product-features-create-page';
// assets
//

// ----------------------------------------------------------------------

export default function CreateProductfeatures() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <ProductFeaturesCreatePage />
        </Container >
    );
}
